import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { UiCol, UiGridColOne, UiGridColTwo } from '../../../../library/layout/Index';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import FormLink from '../../../../library/form/components/FormLink';
import FormROStatus from '../../../../library/form/components/FormROStatus';
import SarasButton from '../../../../library/input/buttons/button/SarasButton2';

const StockCheckListPhysicalEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    const countStatusObj = formObject.getFormData("", "", "countStatus");
    const countStatus = formObject.getValueFromKey(countStatusObj, "val", "");
    const [isAddMoreMode, setIsAddMoreMode] = React.useState(false);

    const actionObj = countStatus === "readonly"
        ? {
            actionParam: { actionType: '' },
            formActions: { forAction: "", forCancel: "Close" }
        }
        : isAddMoreMode ? {
            actionParam: { actionType: 'addMorePhysicalCount' },
            refreshMode: "self",
            formActions: { forAction: "Confirm", forCancel: "Cancel" }
        }
        : countStatus === "count" ? {
            actionParam: { actionType: 'updatePhysicalCount' },
            refreshMode: "self",
            formActions: { forAction: "Confirm", forCancel: "Cancel" }
        } : {
            actionId: "refresh",
            closeOnAction: false,
            actionParam: { actionType: 'resetPhysicalCount' },
            formActions: { forAction: "Count Again", forCancel: "Cancel" }
        };

    const renderAddMoreAction = () => {
        if (countStatus !== "counted" || isAddMoreMode) return null;

        return (
            <SarasButton
                onClick={() => setIsAddMoreMode(true)}
                className="uiActionButton"
                style={{ marginLeft: '10px' }}
            >
                <SarasTrans value="Add More" />
            </SarasButton>
        );
    };

    const renderAddMore = () => {
        if(isAddMoreMode)
            return (<>
                <li>
                    <span className="uiHighlightBlueMedium">
                        <SarasTrans value="Provide Additional Count" />
                    </span>
                </li>
                <li>
                    <span className="uiLbl uiBlue">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "physicalCount1" }} value="Physical Count" />
                    </span>
                    <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                        action={{ InputType: "input", actionId: "", paramName: "addMorephysicalCount1", actionParam:{actionType:""} }}
                        className=''/>
                    <FormROValue useValF={1} formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                    <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                        action={{ InputType: "input", actionId: "", paramName: "addMorephysicalCount2", actionParam:{actionType:""} }} className='uiSpacerH10'/>
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                </li>
                <li>
                    <span className="uiLbl uiRed">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notUsableCount1" }} value="Cannot Use" />
                    </span>
                    <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                        action={{ InputType: "input", actionId: "", paramName: "addMoreNotUsableCount1", actionParam:{actionType:""} }}
                        className=''/>
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                    <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                        action={{ InputType: "input", actionId: "", paramName: "addMoreNotUsableCount2", actionParam:{actionType:""} }} className='uiSpacerH10'/>
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                </li>
            </>);

        return null;
    }

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={actionObj}
            contentStyle={{ height: isAddMoreMode ? '470px' : '350px' }}
            formStyle={{ width: '535px', height: isAddMoreMode ? "520px" : "450px" }} formTitle={<SarasTrans value="Physical Count" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <UiGridColTwo>
                                <UiCol>
                                    <ul>
                                        <li>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "itemId" }} className=""/> /
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "pItemId" }} className="uiSpacerH5"/>
                                        </li>
                                        <li>
                                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "itemName" }}/>
                                        </li>
                                    </ul>
                                </UiCol>
                                <UiCol>
                                    <div style={{ margin: "3px auto", width: "100%", backgroundColor: "#fff", textAlign: "center", minHeight: "60px" }}>
                                        <FormAttachment style={{ cursor: "pointer", maxWidth: "50%", maxHeight: "60px" }} formObject={formObject} rowKey="" action={{ InputType: "i", paramName: "itemImage" }} />
                                    </div>
                                </UiCol>
                            </UiGridColTwo>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "systemCount" }} value="System Count" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "systemCount1" }} className=""/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "systemCount2" }} className=""/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "stockStatus" }} value="Status" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "stockStatus" }} className='uiChip' />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "adjustId" }} >
                            <span className="uiLbl">
                                <div className='uiFlexBox'>
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "adjustId" }} value="Adjust" />
                                    <span className=''><SarasTrans value="Document" /></span>
                                </div>
                            </span>
                            <FormLink formObject={formObject} rowKey="" className="uiLink"
                                action={{paramName: "adjustId"}}
                                linkProp={{ target: "_blank" }}
                            ></FormLink>
                            <FormROStatus compactMode={1} formObject={formObject} rowKey="" action={{ paramName: "adjustStatus" }} className='uiSpacerH5' />
                        </FormWrapper>
                        {isAddMoreMode && (
                        <li>
                            <span className="uiHighlightBlueMedium">
                                <SarasTrans value="Already Counted" />
                            </span>
                        </li>)}
                        <li>
                            <span className="uiLbl uiBlue">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "physicalCount1" }} value="Physical Count" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", actionId: "refresh", paramName: "physicalCount1", actionParam:{actionType:"updateUsableQty"} }}
                                className=''/>
                            <FormROValue useValF={1} formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                                action={{ InputType: "input", actionId: "refresh", paramName: "physicalCount2", actionParam:{actionType:"updateUsableQty"} }} className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                            {renderAddMoreAction()}
                        </li>
                        <li>
                            <span className="uiLbl uiRed">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notUsableCount1" }} value="Cannot Use" />
                            </span>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", actionId: "refresh", paramName: "notUsableCount1", actionParam:{actionType:"updateUsableQty"} }}
                                className=''/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <FormInput style={{width:"70px"}} formObject={formObject} rowKey=""
                                action={{ InputType: "input", actionId: "refresh", paramName: "notUsableCount2", actionParam:{actionType:"updateUsableQty"} }} className='uiSpacerH10'/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "usableCount" }} value="Usable Count" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "usableCount1" }} className=""/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom1" }} className="uiSpacerH10"/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "usableCount2" }} className=""/>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "uom2" }} className="uiSpacerH10"/>
                        </li>
                        {renderAddMore()}
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Comment" />
                            </span>
                            <FormInput style={{width:"250px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", paramName: "comment", actionParam:{} }}
                                className=''/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "storeLocation" }} value="Store Location" />
                            </span>
                            <FormInput style={{width:"250px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", paramName: "storeLocation", actionParam:{} }}
                                className=''/>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(StockCheckListPhysicalEditor, "stockCheckListPhysical", "stockCheckListPhysical,stockCheckListSystem")
